import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useIntl } from 'react-intl';

import { Body1 } from '../Typography';

import styles from './index.module.scss';

export interface ListSubItemTextProps {
  icon: JSX.Element;
  text: string;
}

const ListSubItemText: React.FC<ListSubItemTextProps> = ({ icon, text }) => {
  const intl = useIntl();

  const listSubItemText = intl.formatMessage({
    id: text,
  });
  return (
    <div className={styles.wrapper}>
      {icon}

      <Markdown
        components={{
          p: ({ node, children, ...props }) => (
            <Body1 {...props}>{children}</Body1>
          ),
        }}
        rehypePlugins={[rehypeRaw as any]}
      >
        {listSubItemText}
      </Markdown>
    </div>
  );
};

export default ListSubItemText;
